import { forwardRef, useContext } from 'react'
import { Icons } from '../../..'
import { IconButton } from '../../IconButton'
import { DropdownContext } from '../DropdownContext'

interface Props {}

export const DropdownDefaultTrigger = forwardRef<HTMLButtonElement, Props>((props: Props, ref) => {
  const { isDarkMode } = useContext(DropdownContext)

  return (
    <IconButton variant={isDarkMode ? 'ghostInverted' : 'ghost'} ref={ref} {...props}>
      <Icons.DotsVertical />
    </IconButton>
  )
})
